import { Component, input, output, signal, ViewChild } from '@angular/core';
import { naps_Button, naps_tag_Button } from '../hamburger-state.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-naps-button',
  templateUrl: './naps-button.component.html',
  styleUrl: './naps-button.component.scss',
  standalone: false
})
export class NapsButtonComponent {

  buttonName = input<naps_Button>({ name: '', routeLink: '/' });
  aria_Label = input<string>('');
  tag_Button_Name = input<naps_tag_Button>({
    name: '',
    routeLink: '/'
  });
  dropDownData = input<naps_Button[]>([]);
  isOutLined = input<boolean>(false);
  isDropDownButton = input<boolean>(false);
  isbuttonWithTag = input<boolean>(false);
  isRoutable = input<boolean>(false);
  isOpenNewTab = input<boolean>(false);
  isFilledButton = input<boolean>(false);
  isNoFilledButton = input<boolean>(false);
  clicked = output<string>();
  isDisabledButton = input<boolean>(false);
  isSecondaryOutLined = input<boolean>(false);
  isSecondaryFilled = input<boolean>(false);

  openDropDown = signal<boolean>(false);
  type=input<'submit'|'reset'|'button'>('button')
  @ViewChild('myDrop') myDropDown: NgbDropdown;
  
  onHover(event): void {
    this.myDropDown.toggle();
  }
}
